import React from 'react'
import DialogContent from '@material-ui/core/DialogContent'
import TextField from '@material-ui/core/TextField'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import * as Yup from 'yup'
import {FormattedMessage, useIntl} from 'react-intl'
import {Formik} from 'formik'
import {passwordSchema} from 'lib/schemas'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import LoaderButton from 'components/atoms/LoaderButton'
import Auth from 'lib/auth'
import {FormHelperText} from '@material-ui/core'

const ChangePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required('formValidations.required'),
  newPassword: passwordSchema,
})

export default function ChangePasswordDialog({open, onClose}) {
  const intl = useIntl()
  const {user} = useAuthentication()
  const [errorMessage, setErrorMessage] = React.useState(null)

  async function submitForm(values) {
    setErrorMessage(null)
    const result = await Auth.changePassword(user, values.currentPassword, values.newPassword)
    result.matchWith({
      Ok: () => {
        onClose()
      },
      Error: ({value}) => {
        setErrorMessage(value.message)
      },
    })
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        validationSchema={ChangePasswordSchema}
        initialValues={{currentPassword: '', newPassword: ''}}
        onSubmit={submitForm}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <DialogContent>
              {errorMessage && (
                <FormHelperText error>
                  {intl.formatMessage({id: `changePassword.errors.${errorMessage}`})}
                </FormHelperText>
              )}
              <TextField
                type="password"
                margin="normal"
                fullWidth
                required
                id="current-password"
                name="currentPassword"
                label={intl.formatMessage({id: 'currentPassword'})}
                value={values.currentPassword}
                autoComplete="current-password"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.currentPassword && Boolean(errors.currentPassword)}
                helperText={
                  touched.currentPassword &&
                  errors.currentPassword &&
                  intl.formatMessage({id: errors.currentPassword})
                }
              />
              <TextField
                type="password"
                margin="normal"
                fullWidth
                required
                id="new-password"
                name="newPassword"
                label={intl.formatMessage({id: 'newPassword'})}
                value={values.newPassword}
                autoComplete="new-password"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.newPassword && Boolean(errors.newPassword)}
                helperText={
                  touched.newPassword &&
                  errors.newPassword &&
                  intl.formatMessage({id: errors.newPassword})
                }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="secondary">
                <FormattedMessage id="buttons.cancel" />
              </Button>
              <LoaderButton
                type="submit"
                color="primary"
                isLoading={isSubmitting}
                loadingText={intl.formatMessage({id: 'buttons.savingChanges'})}
              >
                <FormattedMessage id="buttons.saveChanges" />
              </LoaderButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  )
}
